import React from 'react';
import founderAvatar from './founder-avatar.jpg';
import postCardScreenshot from './post-card-screenshot.png';
import createTeamsScreenshot from './create-teams-screenshot.svg';
import { ReactComponent as KeyIcon } from './key-feature-icon.svg';

import './AboutUs.css';

const AboutUs = () => {

  return (
    <div className="page-content__container">
      <div className="page-content">
        <div className='avatar__wrap'>
          <img src={founderAvatar}/>
        </div>
        <div className="article__wrap">
          <h3>About the Sidekick Network</h3>
          <article className="article">
            Rupert Mason founded the Sidekick Network to provide freelancers and businesses with a place to generate their own community of talented professionals and collaborate securely. As a member you&apos;ll be able to offer more services to your clients by posting projects and connecting with freelancers who can help you reach your goals, all in one place.
          </article>
        </div>
        <div className="article__wrap">
          <h3>How does it work?</h3>
          <article className="article create-teams">
            <h5>Get invited to projects or get help with your own.</h5>
            <p>
              Managing all your creative contacts is now a lot easier. Whether you&apos;re an agency or a freelancer you can save all your favourite collaborators in <span className='colorized-span yellow'>teams</span> along with their rates and availability. Good riddance to hairy excel sheets. Build your own teams within our platform and then post a project to invite specific teams to see if they&apos;re available - job done!</p>
          </article>
          <div className="article__after create-teams">
            <img className="article__after_image create-teams" src={createTeamsScreenshot} />
          </div>
          <article className="article create-teams">
            <p>
              To create a project, simply go to <span className="colorized-span yellow">Post an opportunity</span> and fill out the details of your project.
            </p>
            <p>
              IMPORTANT! You can either post a project <span className="colorized-span yellow">privately</span> whereby you invite collaborators that you already know, this could be individually or via your curated teams. The other option is to post <span className="colorized-span yellow">publicly</span> to all members on the platform so you can expand your network.
            </p>
          </article>
          <div className="article__after create-teams">
            <img className="article__after_image post-card" src={postCardScreenshot} />
          </div>
        </div>
        <div className="article__wrap">
          <h3>Once a post is published</h3>
          <article className="article">
            Once your post starts to get interest you can see the emails and portfolios of freelancers who have responded with their availability. Once you&apos;ve found a portfolio that you like you, click <span className="colorized-span blue">Hire</span> That person will be sent an email with you CCd so you can start your project!
          </article>
        </div>
        <div className="article__wrap">
          <h3>Who is it designed for?</h3>
          <article className="article">
            Whether you&apos;re a freelancer, startup or agency; the Sidekick Network is designed to help you find the right people for your projects and help you save all your contacts in one place for future projects and collaborations.
          </article>
        </div>
        <div className="article__wrap">
          <h3>Key features.</h3>
          <div className="features__wrap">
            <ul className="features">
              <li>
                <KeyIcon/>
                <span>Get professional support with your projects</span>
              </li>
              <li>
                <KeyIcon/>
                <span>Invite friends and colleagues to collaborate</span>
              </li>
              <li>
                <KeyIcon />
                <span>Post projects publicly to expand your network</span>
              </li>
              <li>
                <KeyIcon />
                <span>Create curated and specialised teams</span>
              </li>
              <li>
                <KeyIcon />
                <span>Manage freelancer availability</span>
              </li>
              <li>
                <KeyIcon />
                <span>Get last minute projects completed effortlessly</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="email__wrap">
          <span>For any questions or suggestions please contact:</span>
          <a href="mailto:team@sidekicknetwork.co"> team@sidekicknetwork.co</a>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;